import clsx from 'clsx';
import { Image } from '@marriott/mi-ui-library';
import {
  IMerchandisingSmallBannerImage,
  VariationTypes,
} from '../organisms/MerchandisingSmallBanner/MerchandisingSmallBanner.types';

export const MerchandisingSmallBannerImage = (props: IMerchandisingSmallBannerImage) => {
  const { isCobrand, variation, logo, image, customImageClass, isTargetContentLoaded, isVariationsAvailable } = props;

  return (
    <div
      className={clsx(
        variation === VariationTypes.SmallBannerV2
          ? 'merchandising-small-bannerv2__image-container'
          : 'merchandising-small-banner__image-container',
        'mt-md-0',
        isVariationsAvailable && 'withVariation',
        customImageClass,
        !isTargetContentLoaded && 'skeleton-loader-composite loading'
      )}
    >
      {isTargetContentLoaded && (
        <Image
          customClass={clsx({
            'merchandising-small-bannerv2__image': variation === VariationTypes.SmallBannerV2,
            'merchandising-small-banner__image': variation !== VariationTypes.SmallBannerV2,
            'withVariation mr-0': isVariationsAvailable,
            'mr-md-3': isVariationsAvailable && variation === VariationTypes.SmallBannerV2,
            'mr-md-5': isVariationsAvailable && variation !== VariationTypes.SmallBannerV2,
          })}
          altText={isCobrand ? logo?.altText || image?.altText : image?.altText}
          renditions={isCobrand ? [] : image?.renditions}
          dynamic={isCobrand ? false : image?.dynamic}
          defaultImageURL={isCobrand ? (logo ? logo?.imageSrc : image?.assetPath) : image?.assetPath}
        />
      )}
    </div>
  );
};
